import { Component } from '@angular/core';

@Component({
    selector: 'lui-resource-card',
    templateUrl: './resource-card.component.html',
    standalone: false
})
export class ResourceCardComponent {}
